/* eslint-disable import/prefer-default-export */
export const QUESTIONSETS_SELECTOR_KEY = 'questionsets';
